<template>
    <nuxt-link class="app-header-logo flex flex-row my-1" :aria-label="$config.public.siteName" to="/">
        <span class="sr-only">{{ $config.public.siteName }}</span>
        <picture>
            <source :srcset="$config.public.images + $config.public.siteLogoAvif" type="image/avif" media />
            <source :srcset="$config.public.images + $config.public.siteLogoWebp" type="image/webp" media />
            <img :src="$config.public.images + $config.public.siteLogo" width="132" height="61" alt />
        </picture>
    </nuxt-link>
</template>

<script>
export default {
    name: 'AppHeaderLogo',
};
</script>
